const formatStringWithSpaces = (input) => {
  if (!input) return '';
  const formatted = input.replace(/_/g, ' ').toLowerCase();
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export default formatStringWithSpaces;